import * as React from 'react';
import { CSSProperties } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { TextAttributeCfgUIElementState } from '@/stores/TextAttributeCfgUIElementState';
import { AttributeDetails } from '@/UiBuilder/AttributeDetails/AttributeDetails';
import { IAttributeTextData } from '@canvas-logic/clp-domain';
import classNames from 'classnames';
import { AttributeCfgUIElementStateBase } from '@/stores/AttributeCfgUIElementStateBase';

interface Props {
  state: AttributeCfgUIElementStateBase<any>;
  textData: IAttributeTextData;
  children?: React.ReactNode;
}

export const AttributeCfgUIElement = observer(function AttributeCfgUIElement({ state, textData, children }: Props) {
  const { t: tTranslation } = useTranslation('translation');
  const { uiControl } = state.viewElement;
  const selectedTextData = state.selectedTextData;
  if (!state.visible) {
    return null;
  }

  const title = uiControl.showTitle ? textData.name : undefined;
  const description = uiControl.showDescription ? textData.description : undefined;

  return (
    <div
      className={classNames('cp-attribute', 'cp-attribute--' + state.viewElement.type)}
      data-element-id={state.viewElement.id}
      data-component-key={state.componentKey}
      data-attribute-key={state.attributeKey}
    >
      {(title || description) && (
        <div className={classNames('cp-attribute__header')}>
          {title && <span className="cp-attribute__header-title">{title}</span>}
          {description && <span className="cp-attribute__header-description">{description}</span>}
        </div>
      )}
      {children}
      {uiControl.showDetails && <AttributeDetails uiControl={uiControl} selectedTextData={selectedTextData} />}
    </div>
  );
});
